import React, { useState, useEffect } from 'react';
import arrow_down from '../../../images/icons/arrow_down.svg';
import styles from '../../AddLead/AddleadComponent/PropertyDetails.module.css';

function CommonProfession({
  sendUrl,
  sendloanType,
  randomColor,
  handleSelectData
}) {
  const { title_arrow_box, each_box_all, arrow_style, text, box } = styles;
  return (
    <div className="w-full h-full xmd:mt-0">
      <div
        onClick={() => {
          setTimeout(() => {
            handleSelectData();
          }, 500);
        }}
        className={`${each_box_all} xmd:h-full xmd:flex xmd:justify-center  xmd:border xmd:border-blue-100  `}
        style={{
          backgroundColor: randomColor.bgcolor
        }}
      >
        <div className="xmd:mx-auto xmd:h-full xmd:p-5 xmd:w-full ">
          <img
            className="xmd:mx-auto xmd:h-full xmd:w-full"
            src={sendUrl}
            alt=""
          />
        </div>
        <div
          className={`${title_arrow_box} text-black-600 font-roboto font-normal`}
        >
          <div
            className={`${text} xmd:hidden`}
            style={{
              color: randomColor.textcolor
            }}
          >
            {sendloanType}
          </div>
          <div>
            <img
              src={arrow_down}
              alt=""
              className={`${arrow_style} transform -rotate-90 xmd:hidden`}
            />
          </div>
        </div>
      </div>
      <div
        className={`${text} hidden xmd:block`}
        style={{
          color: randomColor.textcolor
        }}
      >
        {sendloanType}
      </div>
    </div>
  );
}
export default CommonProfession;
